module.exports = __webpack_public_path__ + "img/createAccount.f221df62.svg";